module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n\t\t\tTasks\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h3', [_vm._v("Filter")]), _vm._v(" "), _c('h4', [_vm._v("User")]), _vm._v(" "), (_vm.userType != 'User') ? _c('button-group', {
    attrs: {
      "vertical": "true",
      "buttons": _vm.taskUserFilteringButtons,
      "full-width": true
    },
    on: {
      "change": _vm.fetchTasks
    },
    model: {
      value: (_vm.tasksFiltering.user.id),
      callback: function($$v) {
        _vm.tasksFiltering.user.id = $$v
      },
      expression: "tasksFiltering.user.id"
    }
  }) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Status")]), _vm._v(" "), (_vm.userType != 'User') ? _c('button-group', {
    attrs: {
      "vertical": "true",
      "buttons": _vm.tasksFiltering.statusFilterButtons,
      "full-width": true
    },
    model: {
      value: (_vm.tasksFiltering.statusValue),
      callback: function($$v) {
        _vm.tasksFiltering.statusValue = $$v
      },
      expression: "tasksFiltering.statusValue"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('task-list', {
    attrs: {
      "show-owner": true,
      "heading": _vm.tasksFiltering.heading,
      "include-new-button": true,
      "tasks": _vm.filteredTasks,
      "editable": true
    },
    on: {
      "modelChanged": _vm.fetchTasks
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n\t\t\tYour Expenses (" + _vm._s(_vm.fullName) + ") from This Month\n\t\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.expensesWithTokens), function(expense) {
    return _c('tr', {
      key: expense.id
    }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(expense.submitted_at, 'short')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.users.first_name) + " " + _vm._s(expense.users.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.owner_type == "client" ? expense.clients.company : expense.projects.project_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.locations && expense.owner_type == 'client' ? expense.locations.location_name : ''))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa",
      class: {
        'fa-check': expense.processed == 1, 'fa-times': expense.processed == 0
      }
    })]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": expense.receipt_link,
        "target": "_blank"
      }
    }, [_vm._v("View Receipt")])])])
  }), _vm._v(" "), (_vm.expensesWithTokens.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNo Expenses found\n\t\t\t\t\t\t")])]) : _vm._e()], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date Uploaded")]), _vm._v(" "), _c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Client/Project")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Processed")]), _vm._v(" "), _c('th', [_vm._v("View")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a56b57f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 293
// module chunks = 0